export default __webpack_public_path__ + "src/static/img/png/large-arch-cyan.png";